import { useTranslation } from 'react-i18next'

import Lottie from 'react-lottie-player'
import animation from '../../../../assets/animations/search-documents.json'

export default function IsLoadingChooseExample() {
  const { t } = useTranslation()
  return (
    <div className='flex w-full flex-col items-center justify-center'>
      <span className='text-center text-xs font-normal text-rockGrey'>
        {t('discover.create_career.step_1.loading')}
      </span>
      <div className='mt-4'>
        <Lottie animationData={animation} play loop />
      </div>
    </div>
  )
}
